var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('TopNavBar'),_c('SideNavBar'),_c('v-content',[_c('router-view',{key:_vm.$route.fullPath})],1),_c('Footer'),_c('BackTop'),_c('searchModel'),_c('LoginModel'),_c('RegisterModel'),_c('ForgetModel'),_c('EmailModel'),_c('FeedBack')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }